import {gsap} from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger)


// ******************
// Selectors
// ******************
const title = document.querySelector('.nosotros--title')
const subtitle = document.querySelector('.nosotros--subtitle')
const subtitleSplit = new SplitText(subtitle, {type: 'words, chars'})
const introText = document.querySelector('.nosotros--introtext')
const text2 = document.getElementById('nosotrosText2')
const text3 = document.getElementById('nosotrosText3')
const mexico = document.querySelector('.nosotros--mexicoSection')
const mexicoTitle = document.querySelector('.nosotros--mexicoSection__title')
const mexicoText = document.querySelector('.nosotros--mexicoSection__text')
const mexicoSpan = document.querySelector('.nosotros--mexicoSection__title span')

// ******************
// FIRST SECTION
// ******************
window.addEventListener('load', () => {
  
  gsap.set(subtitleSplit.chars, {opacity: 0, scaleY: 3, yPercent: 60, transformOrigin: "50% 0%"});
  const firstAnimation = gsap.timeline()
  .from({}, {duration: 1})
  .from(title, {y: 15, opacity: 0})
  .to(subtitleSplit.chars, {duration: .6, stagger: .03, ease: 'back', yPercent: 0}, '-=.3')
  .to(subtitleSplit.chars, {duration: .4, stagger: .03, ease: "power2.out", opacity: 1, scaleY: 1}, "<+=0.2")
  .from(introText, {y: 15, opacity: 0}, '-=.3')
})


gsap.from(text2, {
  scrollTrigger: {
    start: 'top 70%',
    trigger: text2,
  },
  y: 20, opacity: 0
})

gsap.from(text3, {
  scrollTrigger: {
    start: 'top 70%',
    trigger: text3,
  },
  y: 20, opacity: 0
})


const mexicoAnimation = gsap.timeline({
  scrollTrigger: {
    trigger: mexico,
    start: 'top 70%',
  }
})
.from(mexicoTitle, {y: 20, opacity: 0})
.from(mexicoText, {y: 20, opacity: 0}, '-=.3')
.fromTo(mexicoSpan, {scale: 1}, {scale: 1.5, yoyo: true, repeat:1})
